'use client';

import { motion } from 'framer-motion';
import { Users, DollarSign, BarChart3, Bot } from 'lucide-react';

const stats = [
  { icon: Users, label: 'Users', display: '1M+' },
  { icon: DollarSign, label: 'Total Invested', display: '$89M+' },
  { icon: BarChart3, label: 'Plans Available', display: '6' },
  { icon: Bot, label: 'AI Chatbot Functionality', display: 'Support' },
];

export default function StatsBar() {
  return (
    <section className="border-y border-border bg-bg-secondary">
      <div className="mx-auto max-w-7xl 2xl:px-6 xl:px-5 lg:px-4 md:px-4 px-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
          {stats.map((stat, i) => {
            const Icon = stat.icon;
            return (
              <motion.div
                key={stat.label}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
                className={`px-8 py-10 text-center ${
                  i < stats.length - 1 ? 'lg:border-r lg:border-border' : ''
                } ${i < stats.length - 2 ? 'sm:border-b sm:border-border lg:border-b-0' : ''}`}
              >
                <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-xl border border-accent-amber/20 bg-accent-amber/10">
                  <Icon size={22} className="text-accent-amber" />
                </div>
                <div className="text-ember font-display mb-1.5 text-[clamp(28px,3vw,40px)] font-extrabold">
                  {stat.display}
                </div>
                <div className="text-sm font-medium text-text-muted">{stat.label}</div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
